
export default {
  /** 
   *
   * @param {function} fun 防抖回调函数
   * @param {?Number} delay 延迟时间
   */
  debounce: function (func, delay = 500) {
    let timer = null;
    return (...args) => {
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  },

  /**
   *
   * @param {function} fun 节流回调函数
   * @param {?Number} delay 延迟时间
   */
  throttle: function (func, delay = 500) {
    let timer = null;
    let start = null;
    return (...args) => {
      let now = new Date().getTime();
      !start && (start = now);
      timer && clearTimeout(timer);
      now - start >= delay && (start = now) && func.apply(this, args);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
};